module.exports = [{"label":"None Right Now","value":"None"},{"label":"Automate Studio","value":"Automate Studio App"}]


//////////////////
// WEBPACK FOOTER
// ./src/client/plugins/onboarding/pages/profile-entry/components/early_adopter_program_data.json
// module id = IotK
// module chunks = 23